<template>
  <div class="nuttrema-calivi-view">
    <nuttrema-layout-west-three-vertical>
      <template slot="top-left">
        <div class="top--left__link">
          <a :title="$t('label.close')" @click="$emit('close')">
            <i class="far fa-times"></i>
          </a>
        </div>
      </template>

      <template slot="top-center">
        <div class="top--center__title" >
          <nuttrema-loader v-if="_isNil(ScheduleDetails) || ScheduleDetails.fetching" :showImage="false" :showText="true"></nuttrema-loader>
          <span v-else>
            {{ _get(Schedule, 'start_time') | format-time }}
            <template v-if="isHeaderVisible">
              {{ _get(Schedule, 'start_timestamp') | moment('dddd DD. MMMM') }}
            </template>
            <template v-else>
              {{ _get(Schedule, 'title') || _get(Schedule, 'Entity.name') }}
            </template>
          </span>
        </div>
      </template>

      <template slot="center">
        <nuttrema-loader v-if="_isNil(ScheduleDetails) || ScheduleDetails.fetching"></nuttrema-loader>
        <template v-else>
          <div class="nuttrema-calivi-view__header" v-observe-visibility="visibilityChanged">
            <div class="header__quantity">
               <nuttrema-stuff-to-eat-quantity
                :amount="_get(Schedule, 'amount', 0)"
                :servingSizeTitle="_get(Schedule, 'EntityServingSize.title')"
                :quantityGr="_get(Schedule, 'quantity_gr', 0)"
                :symbol="_get(Schedule, 'EntityServingSize.symbol')">
              </nuttrema-stuff-to-eat-quantity>
            </div>
            <div class="header__name">{{ _get(Schedule, 'title') || _get(Schedule, 'Entity.name') }}</div>
            <div class="header__category">{{ _get(Schedule, 'EntityTypeCategory.name') }}</div>
          </div>
          <div class="nuttrema-calivi-view__content">
            <el-collapse :value="activeNames">

              <el-collapse-item v-if="isHave['note']" :title="$t('label.note')" name="note">
                <p>{{ _get(Schedule, 'note') }}</p>
              </el-collapse-item>

              <el-collapse-item :title="isHave['ingredients'] ? $t('label.nutritions_and_ingredients') : $t('label.nutritions')" name="ingredients">
                <ul class="view__content--list">
                  <li v-for="ingredient in _get(Schedule, 'EntityContents', [])">
                    <div class="list__kcal"><nuttrema-dot-kcal :energyKcal="_get(ingredient, 'energy_kcal', 0)"></nuttrema-dot-kcal></div>
                    <div class="list__description">
                      <div class="list__quantity">
                        <nuttrema-stuff-to-eat-quantity
                          :amount="_get(ingredient, 'amount', 0)"
                          :servingSizeTitle="_get(ingredient, 'ContentServingSize.title')"
                          :quantityGr="_get(ingredient, 'weight_gr', 0)"
                          :symbol="_get(ingredient, 'ContentServingSize.symbol')">
                        </nuttrema-stuff-to-eat-quantity>
                      </div>
                      <div class="list__name">{{ _get(ingredient, 'Content.name') }}</div>
                    </div>
                  </li>
                  <li>
                    <div class="list__kcal"></div>
                    <div class="list__description">
                      <div class="nuttrema-calivi-view__content__nutrition-info">
                        <nuttrema-nutritions-stucture-bars
                          :nutritions="Schedule.NutritionInfo">
                        </nuttrema-nutritions-stucture-bars>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="list__kcal"></div>
                    <div class="list__description">
                      <div class="list__energy">{{ $t('label.energy') }} {{ _get(Schedule, 'summary.energy.energy_kcal_total') | number-format(0) }} kcal / {{ _get(Schedule, 'summary.energy.energy_kj_total') | number-format(0) }} kJ</div>
                    </div>
                  </li>
                </ul>
              </el-collapse-item>

              <el-collapse-item v-if="isHave['instructions']" :title="$t('label.instructions')" name="4">
                <template v-if="_get(Schedule, 'Entity.sbs_instructions')">
                  <ul class="view__content--list">
                    <li v-for="(instruction, index) in _get(Schedule, 'EntityInstructions', [])">
                      <div class="list__seq"><span>{{ index + 1 }}</span></div>
                      <div class="list__description">
                        <div class="list__required_title">{{ _get(instruction, 'title') }}</div>
                        <div class="list__required_time">{{ $t('label.required_time_min', { time: _get(instruction, 'time_required_min') }) }}</div>
                        <div class="list__quantity">{{ _get(instruction, 'instruction') }}</div>
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <p>{{ _get(Schedule, 'Entity.instructions') }}</p>
                </template>
              </el-collapse-item>

              <el-collapse-item v-if="isHave['images']" :title="$t('label.images')" name="5">
                <nuttrema-images-list :images="_get(Schedule, 'EntityImages', [])" theme="embedded"></nuttrema-images-list>
              </el-collapse-item>

              <el-collapse-item v-if="isHave['exchanges']" :title="$t('label.exchanges')" name="6">
                <ul class="view__content--list">
                  <li v-for="exchange in _get(Schedule, 'EntityExchanges', [])">
                    <div class="list__kcal"><nuttrema-dot-kcal :energyKcal="_get(exchange, 'Exchange.energy_kcal', 0)"></nuttrema-dot-kcal></div>
                    <div class="list__description">
                      <div class="list__quantity">
                         <nuttrema-stuff-to-eat-quantity
                          :amount="_get(exchange, 'exchange_amount', 0)"
                          :servingSizeTitle="_get(exchange, 'ExchangeServingSize.title')"
                          :quantityGr="_get(exchange, 'exchange_weight_gr', 0)"
                          :symbol="_get(exchange, 'ExchangeServingSize.symbol')">
                        </nuttrema-stuff-to-eat-quantity>
<!--                         <template v-if="_get(exchange, 'ExchangeServingSize.symbol') === 'g'">
                          {{ _get(exchange, 'exchange_amount', 0) * _get(exchange, 'ExchangeServingSize.amount', 0) | number-format }} {{ _get(exchange, 'ExchangeServingSize.title') }}
                        </template>
                        <template v-else>
                          {{ _get(exchange, 'exchange_amount', 0) | number-format }} {{ _get(exchange, 'ExchangeServingSize.title') }} <span>({{ _get(exchange, 'exchange_weight_gr', 0) | number-format }}g)</span>
                        </template> -->
                      </div>
                      <div class="list__name">{{ _get(exchange, 'Exchange.name') }}</div>
                      <div v-if="_get(exchange, 'ExchangeTypeCategory.name')" class="list__category">{{ _get(exchange, 'ExchangeTypeCategory.name') }}</div>
                    </div>
                  </li>
                </ul>
              </el-collapse-item>

            </el-collapse>
          </div>
        </template>
      </template>
    </nuttrema-layout-west-three-vertical>

  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import NuttremaDotKcal from 'components/ui/label/nuttrema-dot-kcal';
import NuttremaNutritionsStuctureBars from 'components/ui/label/nuttrema-nutritions-stucture-bars';

import NuttremaImagesList from 'components/ui/images/nuttrema-images-list';
import NuttremaStuffToEatQuantity from 'components/ui/label/nuttrema-stuff-to-eat-quantity';

export default {
  name: 'nuttrema-calivi-view',
  props: {
    ScheduleDetails: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaDotKcal,
    NuttremaImagesList,
    NuttremaEmptyResult,
    NuttremaStuffToEatQuantity,
    NuttremaNutritionsStuctureBars,
    NuttremaLayoutWestThreeVertical,
  },
  data() {
    return {
      isHeaderVisible: true,
    };
  },
  computed: {
    Schedule() {
      return get(this.ScheduleDetails, 'data.Children.0') || get(this.ScheduleDetails, 'data');
    },
    isHave() {
      return {
        note: get(this.Schedule, 'note'),
        ingredients: get(this.Schedule, 'EntityContents', []).length > 0,
        instructions: get(this.Schedule, 'EntityInstructions', []).length > 0 || get(this.Schedule, 'Entity.instructions'),
        images: get(this.Schedule, 'EntityImages', []).length > 0,
        exchanges: get(this.Schedule, 'EntityExchanges', []).length > 0,
      };
    },
    activeNames() {
      return get(this.Schedule, 'note') ? ['note'] : ['ingredients'];
    },
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isHeaderVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  $border-color: rgba($gray, 0.15);
  $header-text-color: rgba($gray, 0.6);

  .nuttrema-calivi-view {
    flex-grow: 1;
    display: flex;
    position: relative;
    align-self: stretch;

    .nuttrema-calivi-view__header {
      display: flex;
      align-self: stretch;
      flex-direction: column;
      margin: 0.5em 0 1em 1em;
      flex-shrink: 0;
      width: 100%;

      .header__category, .header__quantity {
        font-weight: 500;
        font-size: 0.9rem;
        color: $header-text-color;
      }
      .header__name {
        font-weight: 400;
        line-height: 1.25;
        font-size: 1.25rem;
      }
    }

    .nuttrema-calivi-view__content {
      padding-left: 1em;
      background-color: #fff;
      margin-bottom: 7em;
      /deep/ .el-collapse {
        width: 100%;
        margin-top: -1px;
        margin-bottom: -1px;
        .el-collapse-item__content {
          line-height: 1.5;
          padding-right: 1em;
          padding-bottom: 1em;
        }
      }

      .nuttrema-calivi-view__content__nutrition-info {
        max-width: 24em;
        margin-bottom: 0.5em;
      }

      .view__content--list {
        > li {
          display: flex;
          flex-shrink: 0;
          padding: 0.5em 0;
          border-bottom: 1px solid $border-color;

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            border-bottom: none;
          }

          .list__kcal {
            min-width: 2em;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .list__seq {
            min-width: 2em;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            > span {
              display: inline-block;
              width: 1.75em;
              height: 1.75em;
              border-radius: 50%;
              background-color: gray;
              color: #fff;
              text-align: center;
              line-height: 1.7em;
              font-weight: 500;
              font-size: 0.8em;
            }
          }

          .list__description {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
          }

          .list__quantity {
            line-height: 1.55;
            font-size: 0.85rem;
          }

          .list__category {
            line-height: 1.25;
            font-size: 0.85rem;
          }

          .list__name {
            font-weight: 500;
            line-height: 1.25;
          }

          .list__required_title {
            font-weight: 500;
            line-height: 1.5;
            font-size: 0.9rem;
            margin-bottom: 0.25em;
          }

          .list__required_time {
            line-height: 1.5;
            font-size: 0.7rem;
            margin-bottom: 0.25em;
            text-transform: uppercase;
            color: gray;
          }

          .list__energy {
            padding: 0.5em 0 0 0;
            font-weight: 600;
            line-height: 1.25;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/schedules/nuttrema-calivi-view.vue